/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draftscount1Inputs */

const en_draftscount1 = /** @type {(inputs: Draftscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} drafts simultaneously`)
};

const de_draftscount1 = /** @type {(inputs: Draftscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Entwürfe gleichzeitig`)
};

/**
* | output |
* | --- |
* | "{count} drafts simultaneously" |
*
* @param {Draftscount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const draftscount1 = /** @type {((inputs: Draftscount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draftscount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draftscount1(inputs)
	return de_draftscount1(inputs)
});
export { draftscount1 as "draftsCount" }